export const LeadQualificationType = {
	PRODUCT_QUALIFIED: 'product_qualified',
	UNQUALIFIED: 'unqualified',
	SALES_QUALIFIED: 'sales_qualified',
} as const;

export const TeamSizeType = {
	LARGE: '25+',
} as const;

export const ClientType = {
	SMALL: '0-2',
} as const;

export const RevenueType = {
	SMALL: '0-10k',
	MEDIUM: '100k-250k',
	LARGE: '250k+',
} as const;

export const CompanyType = {
	SOLOPRENEUR: 'solopreneur',
} as const;

export const PremiumPartnershipCommitment = {
	YES: 'yes',
	NO: 'no',
} as const;
